config.$inject = ['$stateProvider']
function config($stateProvider){
  $stateProvider
    .state('main.dashboard', {
      url: 'dashboard',
      template: '<dashboard></dashboard>'
    })
}

export default config